"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppManagingAccount = void 0;
const Application_ts_1 = require("./Application.js");
/**
 * App that manages a CMC-enabled HDS account (doctor / researcher side).
 *
 * Post-plan-61 Phase C, all form-storage and patient-invite management
 * lives in CMC: form templates are `hds-form-spec/v1` events on
 * `:_cmc:apps:hds-collector:<collectorId>` (use `cmcFormSpec.listFormSpecs`
 * + `getFormSpecById` + the consumer-side `cmcDoctor.saveFormSpec`), and
 * patient invites go through `cmc.createInvite` / `listInvites` /
 * `acceptInvite`.
 *
 * AppManagingAccount itself now provides only the base `Application`
 * surface (init, connection, baseStreamId) — no legacy Collector
 * lifecycle.
 */
class AppManagingAccount extends Application_ts_1.Application {
    // used by Application.init();
    // No `mustBeMaster`: doctor-dashboard and bridge-redcap log in with an `app` access scoped to their base
    // stream (+ profile, CMC), never `*` / manage (B-2026-10-07-6).
    get appSettings() {
        return {
            canBePersonnal: true,
            appNameFromAccessInfo: true // application name will be taken from Access-Info Name
        };
    }
}
exports.AppManagingAccount = AppManagingAccount;
